(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('PdfViewerModalController', ["$scope", "$modalInstance", "encodedData", "options", "modalSingletons", function ($scope, $modalInstance, encodedData, options, modalSingletons) {
        $scope.options = $.extend({ display: 'text' }, options, true);
        $scope.close = function () {
            $modalInstance.close();
            modalSingletons.close(options.singleton);
        };
        $scope.$on('$routeChangeSuccess', function () {
            $scope.close();
        });
        setTimeout(function () {
            // encodedData is an encoded PDF content by base64.
            var pdfViewLink = 'data:application/pdf;base64,' + encodedData;
            angular.element('#pdf-viewer-object').attr('data', pdfViewLink);
            angular.element('#pdf-viewer-embed').attr('src', pdfViewLink);
            if (!options.hideBottom && options.enableDownload) {
                var pdfDownloadLink = 'data:application/octet-stream;base64,' + encodedData;
                angular.element('#dwnldLnk').attr('href', pdfDownloadLink);
                angular.element('#dwnldLnk').attr('download', options.fileName);
            }
        }, 500);
    }]);
    m.factory('pdfViewerModal', ["$modal", "path", "modalSingletons", function ($modal, path, modalSingletons) {
        return {
            show: function (encodedData, options, size) {
                options = $.extend(true, {}, options);
                if (options.singleton) {
                    if (modalSingletons.isOpen(options.singleton)) {
                        return modalSingletons.getInstance(options.singleton);
                    }
                }
                var modalInstance = $modal.open({
                    templateUrl: path('common').ctrl('pdf-viewer-modal').template(),
                    controller: 'PdfViewerModalController',
                    size: size,
                    backdrop: _(options).isObject() && !_(options.backdrop).isUndefined() ? options.backdrop : true,
                    keyboard: _(options).isObject() && !_(options.keyboard).isUndefined() ? options.keyboard : true,
                    resolve: {
                        encodedData: _.constant(encodedData),
                        options: _.constant(options)
                    },
                    windowClass: options.windowClass
                });
                if (options.singleton) {
                    modalSingletons.open(options.singleton, modalInstance.result);
                }
                return modalInstance.result;
            }
        };
    }]);
}());